import React from "react";
import "../../css/Button.css";

function Button({
  text,
  onClick,
  variant = "primary", // 'primary', 'secondary', 'outline'
  size = "medium", // 'small', 'medium', 'large'
  className = "",
}) {
  return (
    <button
      className={`btn btn-${variant} btn-${size} ${className}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
}

export default Button;
